import React, { useEffect, useState } from "react";
import Close from "../assets/Modal-Close-Icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux-store/store";
import "../modal/popup-main.css";
import ReloaderIcon from "../assets/Reloader.svg";
import CopyIcon from "../assets/copyicon.svg";
import CopiedIcon from "../assets/passwwordCopied.svg";
import {
  API_UserControl,
  GetAllUser,
} from "../../../api/ssoapi/UserControlapi";
import {
  showErrorNotification,
  showSuccessNotification,
} from "../modal/Tostify";
import {
  IUserFilterModel,
  UserControlSlices,
} from "../../../slices/UserControlSlice";

const labelElement: React.CSSProperties = {
  fontSize: "14px",
  fontFamily: "DiscoverSans-Medium",
  fontWeight: "600",
  color: "#8e8e8e",
};
const labelvalue: React.CSSProperties = {
  fontSize: "12px",
  fontFamily: "DiscoverSans-Medium",
  fontWeight: "400",
  color: "#000",
};
const PasswordGenerator: React.FC = () => {
  const { generatePassword } = useSelector(
    (state: RootState) => state.userControl
  );
  const dispatch = useDispatch<AppDispatch>();
  const [password, setPassword] = useState<string>("");
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const { searchFilter } = useSelector((state: RootState) => state.userControl);

  const handleClose = (): void => {
    dispatch(UserControlSlices.UpdateEnableGeneratePassword(false));
  };

  const generatePassowrd = async (): Promise<void> => {
    try {
      setIsCopied(false);
      const response = await API_UserControl.GeneratePassword();

      setPassword(response.data.data);
    } catch (error) {
      showErrorNotification("Something Went Error, Please try again later");
    }
  };
  useEffect(() => {
    generatePassowrd();
  }, []);

  // submit generator password
  const handleTosubmitGeneratePassword = async (): Promise<void> => {
    let ISearchFilter = Object.assign({}, searchFilter.apiQuery);
    ISearchFilter.filters = [];
    try {
      await API_UserControl.SubmitTempPassword({
        clientID: generatePassword.generatorId,
        emailID: generatePassword.generatorEmail,
        tempPassword: password,
      }).then(() => {
        dispatch(UserControlSlices.UpdateEnableGeneratePassword(false));
        dispatch(
          UserControlSlices.UpdateGeneratePassword({
            generatorEmail: "",
            generatorId: "",
          })
        );
        showSuccessNotification("Password Generate Sucessfully");
        if (searchFilter.globalSearch.value) {
          let lQuery: IUserFilterModel = {
            filters: searchFilter.globalSearchApiQuery.filters,
            isAscending: false,
            currentPageSize: searchFilter.apiQuery.currentPageSize,
            pageSize: searchFilter.apiQuery.pageSize,
            page: 1, //First time always get page 1
            isOr: true,
            isPageChanged: "",
            sortField: "",
          };

          dispatch(GetAllUser(lQuery));
        } else {
          dispatch(GetAllUser(ISearchFilter));
        }
      });
    } catch (error) {
      showErrorNotification("Something Went Error, Please try again later");
    }
  };

  // function for password copy to clipboard
  const setClipboardValue = async (value: string) => {
    try {
      // Check if the Clipboard API is available
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(value);
        setIsCopied(true);
        showSuccessNotification("Password has been copied successfully");
      }
    } catch (error) {
      showErrorNotification("Clipboard API not supported");
    }
  };
  return (
    <div className="modal-overlay">
      <div className="password-modal-content">
        <div className="password-modal-header">
          <span className="popup-head">Password Generator</span>
          <img
            src={Close}
            alt="password-close-icon"
            className="close-btn"
            onClick={handleClose}
          />
        </div>
        <div className="password-modal-body">
          <div className="password-main-container">
            <div className="password-container">
              <div style={labelElement}>Password</div>
              <div style={labelvalue}>{password}</div>
            </div>
            <img
              src={ReloaderIcon}
              alt="reloadIcon"
              className="password-icons"
              onClick={generatePassowrd}
            />
            {isCopied ? (
              <img src={CopiedIcon} alt="CopiedIcon" />
            ) : (
              <img
                src={CopyIcon}
                alt="copyIcon"
                className="password-icons"
                onClick={() => setClipboardValue(password)}
              />
            )}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginRight: "49px",
              marginTop: "30px",
            }}
          >
            <button
              className="popup-create-btn"
              onClick={handleTosubmitGeneratePassword}
            >
              Submit
            </button>
            <button className="popup-Cancel-btn" onClick={handleClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordGenerator;
